import client from "./client";

export function getFields(params = {}) {
    const response = client.get("/api/fields", {
        params
    });
    return response;
}

export function getFieldTypes() {
    const response = client.get("/api/field-types");
    return response;
}

export function getField(id) {
    const response = client.get(`/api/fields/${id}`);
    return response;
}

export function updateField(id, data) { 
    const response = client.put(`/api/fields/${id}`, data);
    return response;
}

export function addField(data) {
    const response = client.post(`/api/fields`, data);
    return response;
}

export function deleteField(id) {
    const response = client.delete(`/api/fields/${id}`);
    return response;
}
